import z from 'zod';

export function generateAdditionalRequirementSchema(index) {
    const descriptionSchema = z.string()
        .min(1, 'Description is required')
        .max(100, 'Description must be at most 100 characters');

    const priceSchema = z.number({ invalid_type_error: 'Price must be a number' })
        .refine((val) => val !== 0, { message: 'Price is required' })
        .refine((val) => val > 0, { message: 'Price must be a positive number' });

    const attachments = z.array(z.object({
        id: z.string().optional(),
        name: z.string().optional(),
        category: z.string().optional(),
        note: z.string().optional(),
        signedUrl: z.string().optional(),
        metadataId: z.string().optional(),
    })).optional();

    return z.object({
        [`id-${index}`]: z.string().optional(),
        [`files-${index}`]: attachments,
        [`description-${index}`]: descriptionSchema,
        [`priceEstimate-${index}`]: priceSchema,
    });
}